<template>
  <el-dialog
    class="supply-dialog"
    :visible.sync="supplyDialogVisible"
    :close-on-click-modal="false"
    width="680px"
    @close="handleSupplyDialogClose"
  >
    <div slot="title">
      <div class="title">{{ isEdit ? "编辑档口档案" : "新建档口" }}</div>
      <div v-if="isEdit && editDisabled" class="edit-tip">
        置灰字段，请在ys-档口黄页进行修改
      </div>
    </div>

    <el-form
      ref="supplyFormRef"
      label-width="140px"
      :rules="rules"
      :model="supplyForm"
    >
      <el-form-item label="品牌名(APP内展示)" prop="brand_name">
        <el-input
          v-model="supplyForm.brand_name"
          placeholder="请输入一手商城档口名，在App内展示（20个字）"
          :maxlength="20"
          :disabled="editDisabled"
        ></el-input>
      </el-form-item>
      <el-form-item label="" prop="alias_brand_name">
        <el-button
          v-if="supplyForm.alias_brand_name.length < 4"
          type="primary"
          style="margin-bottom: 20px"
          @click="addAliasBrandName"
        >
          增加品牌别名
        </el-button>
        <div
          v-for="(item, index) in supplyForm.alias_brand_name"
          :key="index"
          style="display: flex; margin-bottom: 20px"
        >
          <el-input
            v-model="supplyForm.alias_brand_name[index]"
            :maxlength="20"
            placeholder="请输入别名"
          ></el-input>
          <el-button
            style="margin-left: 20px"
            type="danger"
            @click="delAliasBrandName(index)"
          >
            删除
          </el-button>
        </div>
      </el-form-item>

      <el-form-item label="城市" prop="city">
        <el-select
          v-model="supplyForm.city"
          filterable
          placeholder="城市"
          :disabled="editDisabled"
          @change="handleSelectCity"
        >
          <el-option
            v-for="item in cityList"
            :key="item.key"
            :label="item.label"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="市场" prop="first_market_id">
        <el-select
          v-model="supplyForm.first_market_id"
          filterable
          placeholder="市场"
          :disabled="editDisabled"
          @change="setChild"
        >
          <el-option
            v-for="item in marketList"
            :key="item.key"
            :label="item.label"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="子市场" prop="market_id">
        <el-select
          v-model="supplyForm.market_id"
          filterable
          placeholder="子市场"
          :disabled="editDisabled"
        >
          <el-option
            v-for="item in subMarketList"
            :key="item.key"
            :label="item.label"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="是否可提前订阅" prop="show_app">
        <el-radio-group v-model="supplyForm.show_app">
          <el-radio label="1">可提前订阅</el-radio>
          <el-radio label="2">不可提前订阅</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="楼层" prop="floor">
        <el-select
          v-model="supplyForm.floor"
          filterable
          placeholder="楼层"
          :disabled="editDisabled"
        >
          <el-option
            v-for="item in floorList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="区域/街" prop="area_id">
        <el-select
          v-model="supplyForm.area_id"
          filterable
          placeholder="区域/街"
          :disabled="editDisabled"
        >
          <el-option
            v-for="item in areaList"
            :key="item.supply_area_id"
            :label="item.supply_area"
            :value="item.supply_area_id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="档口号">
        <el-input
          v-model="supplyForm.supplier_num"
          placeholder="档口门牌等信息（最长 20个字符）"
          :disabled="editDisabled"
          :maxlength="20"
        ></el-input>
      </el-form-item>

      <el-form-item label="档口logo(填写后，在App内展示）" prop="avatar">
        <el-upload
          class="avatar-uploader"
          :action="action"
          :show-file-list="false"
          :on-success="uploadSuccess"
          :before-upload="uploadBefore"
          accept="image/*"
          with-credentials
        >
          <img
            v-if="supplyForm.avatar"
            :src="supplyForm.avatar"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon" />
        </el-upload>
      </el-form-item>
      <el-form-item label="档口简介(填写后，在App内展示）" prop="description">
        <el-input
          v-model="supplyForm.description"
          type="textarea"
          :rows="2"
          maxlength="200"
          show-word-limit
          placeholder="请输入档口简介，若填写，将在app内展示"
        >
        </el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="supplyDialogVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="handleSubmit">
          {{ isEdit ? "保存" : "确认新增" }}
        </el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import { getOps, detail, add, edit } from "@/controller/supplyApply3750.js";

export default {
  name: "Bulletin",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      aliasBrandName: [], // 别名数组
      supplyDialogVisible: false,
      isEdit: false,
      supplyForm: {
        sa_id: "",
        brand_name: "",
        city: "",
        supply_id: "",
        subscribe_num: "",
        market_name: "",
        market_id: "",
        first_market_id: "",
        show_app: "1",
        floor: "",
        area_id: "",
        supplier_num: "",
        avatar: "",
        description: "",
        alias_brand_name: [],
      },
      editDisabled: false,
      cityList: {},
      marketList: [],
      subMarketList: [],
      floorList: [],
      areaList: [],
      action: `${apiBaseURL}/erp/Common/erpUploadFile`,
      rules: {
        brand_name: [
          {
            required: true,
            message: "请填写档口名，最长不超过20个字符",
            trigger: "blur",
          },
        ],
        city: [{ required: true, message: "请选择所在城市", trigger: "blur" }],
        first_market_id: [
          { required: true, message: "请选择所在市场", trigger: "blur" },
        ],
        market_id: [
          { required: true, message: "请选择所在子市场", trigger: "blur" },
        ],
        show_app: [
          {
            required: true,
            message: "请选择是否可提前订阅选项",
            trigger: "blur",
          },
        ],
      },
    };
  },

  methods: {
    delAliasBrandName(index) {
      this.supplyForm.alias_brand_name.splice(index, 1);
    },
    addAliasBrandName() {
      this.supplyForm.alias_brand_name.push("");
    },
    showSupplyDialog(saId, status) {
      this.supplyDialogVisible = true;
      // 判断是否为编辑
      if (saId !== "") {
        this.isEdit = true;
        // 非未提交审核状态，限制某些字段编辑
        if (status !== "8") {
          this.editDisabled = true;
        }
        this.getSupplyDetail(saId);
      }
      // 获取下拉数据
      this.getSelectionList();
    },
    // 获取弹框详情
    getSupplyDetail(saId) {
      detail({ sa_id: saId }).then((res) => {
        const { detail: detailData } = res;
        // 处理城市筛选项问题
        if (detailData.city) {
          this.handleSelectCity(detailData.city);
          this.setChild(detailData.first_market_id);
        }
        this.supplyForm = detailData;
      });
    },
    // 提交修改
    handleSubmit() {
      this.$refs.supplyFormRef.validate(async (valid) => {
        if (valid) {
          let requestApi = add;
          if (this.isEdit) {
            requestApi = edit;
          }
          // 请求参数
          const params = {
            ...this.supplyForm,
            // 去除左右空格
            brand_name: this.supplyForm.brand_name.trim(),
            alias_brand_name: this.supplyForm.alias_brand_name
              .map((item) => item.trim())
              .filter((item) => !!item),
          };
          requestApi(params).then(() => {
            this.$message.success("操作成功");
            this.supplyDialogVisible = false;
            this.$emit("submit-success");
          });
        }
      });
    },
    // 获取下拉筛选列表
    getSelectionList() {
      getOps().then((res) => {
        const { cities, floor, area } = res;
        this.cityList = cities;
        this.floorList = floor;
        this.areaList = area;
      });
    },
    // 筛选城市
    handleSelectCity(value) {
      // 重置数据
      this.supplyForm.father_market = "";
      this.supplyForm.first_market_id = "";
      this.supplyForm.market_id = "";
      this.marketList = [];
      this.subMarketList = [];
      this.$http
        .post("/erp/Supply/getMainMarket", { city: value })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.marketList = res.data.data;
          }
        });
    },
    // 获取二级市场列表
    setChild(value) {
      // 重置数据;
      this.supplyForm.market_id = "";
      this.subMarketList = [];
      this.$http
        .post("/erp/Supply/getChildMarket", { parent_id: value })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.subMarketList = res.data.data;
          }
        });
    },
    // 上传成功
    uploadSuccess(rs) {
      console.log("uploadSuccess", rs);
      if (rs.code !== 200) return this.$message.error("上传失败! 请重试");

      const file = rs.data.origin_files[0];

      const image = new Image();
      image.src = file;
      const that = this;
      image.onload = function () {
        const { width, height } = image;
        if (width !== height) {
          that.$message.error("必须上传正方形");
        } else if (width > 800 || width < 130 || height > 800 || height < 130) {
          that.$message.error("长宽必须在130px~800px之间");
        } else {
          that.$set(that.supplyForm, "avatar", file);
        }
      };
      return true;
    },
    // 上传之前, 判断文件格式
    uploadBefore(file) {
      const typePrefix = file.type.split("/")[0];
      if (typePrefix !== "image") {
        this.$message.error("请选择图片文件");
        return false;
      }
      return true;
    },
    handleSupplyDialogClose() {
      this.supplyForm = this.$options.data().supplyForm;
      this.$refs.supplyFormRef.resetFields();
      // 初始化状态
      this.editDisabled = false;
      this.isEdit = false;
    },
  },
};
</script>

<style>
.supply-dialog .title {
  font-weight: bold;
  font-size: 22px;
}

.supply-dialog .edit-tip {
  height: 1;
  font-size: 14px;
  color: #666;
}

.supply-dialog .avatar-uploader-icon {
  border: 1px solid #ccc;
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.supply-dialog .avatar {
  max-width: 178px;
  max-height: 178px;
  display: block;
}

.supply-dialog .el-dialog__body {
  padding: 10px 20px;
}

.supply-dialog .el-form-item {
  margin-bottom: 18px;
}
</style>



// WEBPACK FOOTER //
// src/pages/supplyapply/components/SupplyMessageDialog.vue